import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4e6901da"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  key: 0,
  class: "tab_container"
};
import { computed, defineAsyncComponent, ref, watch } from 'vue';
import { reportEvent } from '@/common';
import { useStore } from '@/store';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const store = useStore();
    /** 检查是否有某权限：管理员(*) 或 精确匹配 permissionCode */
    function hasPermission(permissionCode) {
      const userInfo = store.getParsedUserInfo;
      if (!(userInfo !== null && userInfo !== void 0 && userInfo.permissions)) return false;
      const permissions = userInfo.permissions;
      if (permissions.some(item => item === '*')) return true;
      return permissions.some(item => item === permissionCode);
    }
    const tabKey = ref('taskWarning');
    const tabList = [{
      key: 'taskWarning',
      label: '预警任务',
      permissionCode: 'bizMonitor:view',
      component: defineAsyncComponent(() => import('./taskWarning/index.vue'))
    }, {
      key: 'thresholdPlan',
      label: '阈值方案',
      permissionCode: 'thresholdPlan:view',
      component: defineAsyncComponent(() => import('./thresholdPlan/index.vue'))
    }];
    const visibleTabList = computed(() => tabList.filter(item => hasPermission(item.permissionCode)));
    // 当可见 tab 变化时，确保当前选中的 key 在可见列表中
    watch(visibleTabList, list => {
      const keys = list.map(t => t.key);
      if (!keys.length) return;
      if (!keys.includes(tabKey.value)) {
        tabKey.value = keys[0];
      }
    }, {
      immediate: true
    });
    function handleTabChange(key) {
      var _tabList$find;
      tabKey.value = key;
      const tablabel = (_tabList$find = tabList.find(item => item.key === key)) === null || _tabList$find === void 0 ? void 0 : _tabList$find.label;
      reportEvent({
        eventName: 'element_use',
        properties: {
          ui_name: '订单监控',
          element_name: `切换${tablabel}`
        }
      });
    }
    const curComp = computed(() => {
      var _list$find;
      const list = visibleTabList.value;
      if (!list.length) return null;
      const item = (_list$find = list.find(t => t.key === tabKey.value)) !== null && _list$find !== void 0 ? _list$find : list[0];
      return item.component;
    });
    return (_ctx, _cache) => {
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_unref(visibleTabList).length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_a_tabs, {
        activeKey: tabKey.value,
        "onUpdate:activeKey": _cache[0] || (_cache[0] = $event => tabKey.value = $event),
        onChange: handleTabChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(visibleTabList), item => {
          return _openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.key,
            tab: item.label
          }, null, 8, ["tab"]);
        }), 128))]),
        _: 1
      }, 8, ["activeKey"])])) : _createCommentVNode("", true), _unref(curComp) ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(curComp)), {
        key: 1
      })) : _createCommentVNode("", true)])]);
    };
  }
});